import React from "react";
import { Mail, Phone, MapPin } from "lucide-react";
import { useTranslation } from "@/context/LanguageContext";

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#064e3b] text-green-50 relative overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10 py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-2xl bg-white/95 grid place-items-center p-1.5">
              <img src="/purvodaya-logo.png" alt="Purvodaya Solar" className="w-full h-full object-contain" />
            </div>
            <div>
              <div className="font-display font-extrabold text-xl">
                Purvodaya <span className="text-orange-400">Solar</span>
              </div>
              <div className="text-[11px] uppercase tracking-[0.18em] text-yellow-300">
                {t("footer.tag")}
              </div>
            </div>
          </div>
          <p className="mt-4 max-w-md text-green-200 leading-relaxed">
            {t("footer.desc")}
          </p>
        </div>

        <div>
          <div className="font-semibold text-white">{t("footer.explore")}</div>
          <ul className="mt-3 space-y-2 text-sm">
            <li><a href="#how" className="hover:text-yellow-300">{t("nav.how")}</a></li>
            <li><a href="#subsidy" className="hover:text-yellow-300">{t("nav.subsidy")}</a></li>
            <li><a href="#calculator" className="hover:text-yellow-300">{t("nav.savings")}</a></li>
            <li><a href="#workflow" className="hover:text-yellow-300">{t("nav.process")}</a></li>
            <li><a href="#faq" className="hover:text-yellow-300">{t("nav.faq")}</a></li>
          </ul>
        </div>

        <div>
          <div className="font-semibold text-white">{t("footer.contact")}</div>
          <ul className="mt-3 space-y-3 text-sm">
            <li className="flex gap-2 items-start"><Phone className="w-4 h-4 mt-0.5 text-yellow-300" /> +91 11 6926 8785</li>
            <li className="flex gap-2 items-start"><Mail className="w-4 h-4 mt-0.5 text-yellow-300" /> support@purvodayasolar.com</li>
            <li className="flex gap-2 items-start"><MapPin className="w-4 h-4 mt-0.5 text-yellow-300" /> India</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-green-700/60 px-5 md:px-10 py-5 text-xs text-green-300 max-w-7xl mx-auto flex flex-wrap justify-between gap-3">
        <div>{t("footer.rights", { year: new Date().getFullYear() })}</div>
        <div>{t("footer.built")}</div>
      </div>
    </footer>
  );
}
